// extracted by mini-css-extract-plugin
module.exports = {"titleWithIcon":"_3UGBl5","margin-lg":"_2B-Tin","margin-md":"JaAcGn","margin-sm":"_2xCGmI","icon":"_2mZdKZ"};